import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/token/:tokenAuth?';

const AuthRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/Auth/Auth.verify')),
    name: 'AuthVerify',
};

export default AuthRoute;
